<div id="requests-list" class="flex flex-col gap-3">
  <div class="flex w-full justify-end mb-4">
    <div class="w-full" style="width: 200px">
      <label class="block text-sm font-medium mb-2">Filter by Status</label>
      <nz-select nzPlaceHolder="Select status..." [(ngModel)]="status" (ngModelChange)="filterRequests()"
        class="w-full">
        @for (item of statuses; track item) {
        <nz-option [nzValue]="item" [nzLabel]="item | translate"></nz-option>
        }
      </nz-select>
    </div>
  </div>

  <nz-table #nzTable [nzData]="listOfDisplayData" nzTableLayout="fixed" [nzLoading]="!reportRequests">
    <thead>
      <tr>
        <th nzCustomFilter>
          Requester
          <nz-filter-trigger [(nzVisible)]="visible" [nzActive]="searchValue.length > 0" [nzDropdownMenu]="menu">
            <nz-icon nzType="search" />
          </nz-filter-trigger>
        </th>
        <th>Patient</th>
        <th>Request Time</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (request of nzTable.data; track request.id) {
      <tr>
        <td>{{ request.requested_by.name }}</td>
        <td>{{ request.requested_for.name }}</td>
        <td>{{ request.requested_at }}</td>
        <td>
          <app-tag [text]="request.status"></app-tag>
        </td>
        <td>
          <button nz-button nzType="primary" nzSize="small" (click)="openRequests(request)">
            View Details
          </button>
          <nz-divider nzType="vertical"></nz-divider>
          <button nz-button nzType="primary" nzShape="round" (click)="deleteRequest(request.id)" nzDanger>
            <nz-icon nzType="delete" />
          </button>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="5" class="text-center py-8 text-gray-500">
          No requests found for the selected status
        </td>
      </tr>
      }
    </tbody>
  </nz-table>

  @if (total > pageSize) {
  <div class="flex justify-center mt-4">
    <nz-pagination [nzPageIndex]="page" [nzTotal]="total" [nzPageSize]="pageSize" [nzShowSizeChanger]="false"
      [nzShowQuickJumper]="true" [nzShowTotal]="totalTemplate" (nzPageIndexChange)="onPageChange($event)">
    </nz-pagination>
  </div>
  }

  <ng-template #totalTemplate let-total let-range="range">
    {{ range[0] }}-{{ range[1] }} of {{ total }} requests
  </ng-template>

  <nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input type="text" nz-input placeholder="Search requester or patient name" [(ngModel)]="searchValue" />
        <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button>
        <button nz-button nzSize="small" (click)="reset()">Reset</button>
      </div>
    </div>
  </nz-dropdown-menu>
</div>
